import { formatBytes } from 'src/utils/formatNumber.js';

type Props = {
  usedSpaceBytes: number;
  totalSpaceBytes: number;
};

type ReturnType = {
  usedPercentage: number;
  usedSpace: string;
  totalSpace: string;
};

export function calculateSpaceUsage({
  usedSpaceBytes,
  totalSpaceBytes,
}: Props): ReturnType {
  if (!totalSpaceBytes) {
    totalSpaceBytes = 500 * 1_073_741_824;
  }

  const usedPercentage = (usedSpaceBytes / totalSpaceBytes) * 100;

  return {
    usedPercentage: parseFloat(usedPercentage.toFixed(2)),
    usedSpace: formatBytes(usedSpaceBytes),
    totalSpace: formatBytes(totalSpaceBytes),
  };
}
